import React from 'react';
import background from '../assets/login-background.jpg';
import logoText from '../assets/logo-text.svg';
import xsmallLoader from '../assets/loader-xs.svg';
import { Redirect } from 'react-router-dom';
import { baseUrl } from './url';

const Background = {
    backgroundImage: `url(${background})`
}
class Login extends React.Component{
    constructor(){
        super()
        this.state = {
            login:false,
            email: '',
            password: '',
            emailError: '',
            passwordError: '',
            error: '',
            noResponse: true
        }
        this.handleEmail = this.handleEmail.bind(this)
        this.handlePassword = this.handlePassword.bind(this)
        this.login = this.login.bind(this)
    }
    handleEmail(e){
        this.setState({
            email: e.target.value,
            emailError: '',
            error:''
        })
    }
    handlePassword(e){
        this.setState({
            password: e.target.value,
            passwordError: '',
            error:''
        })
    }
    login=(e)=>{
        e.preventDefault();
        if(!this.state.email && !this.state.password){
            this.setState({
                emailError:'please enter your email',
                passwordError: 'please enter your password'
            })
        }
        else if(!this.state.email){
            this.setState({emailError:'please enter your email'})
        }else if(!this.state.password){
            this.setState({passwordError:'please enter your password'})
        }else{
            this.setState({emailError:'',passwordError:'',noResponse:false})

            fetch(`${baseUrl}/admin/login`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: this.state.email,
                    password: this.state.password
                })
            }).then((response) => response.json())
            .then((responseJson) => {
                if(!responseJson.data){
                    this.setState({
                        error:'Email or password is incorrect',
                        noResponse: true
                    })
                }else{
                    const token = responseJson.data.token;
                    localStorage.setItem('access_token', token);
                    this.setState({login:true})
                }
            })
            .catch((error) => {
                console.error(error);
            });
        }
    }
    render(){
        const token = localStorage.getItem('access_token');
        const login = this.state.login;  
        if (token || login) {
            return <Redirect exact to='/dashboard'/>;
        }   
        return(
            <div className="login-section" style={Background}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
                            <div className="login-card">
                                <img src={logoText} alt="" className="login-logo"/>
                                {this.state.error && <p className="error"><small>{this.state.error}</small></p>}
                                <form onSubmit={this.login}>
                                    <label>
                                        Email
                                        <input type="email" onChange={this.handleEmail}/>
                                        {this.state.emailError && <p className="error"><small>{this.state.emailError}</small></p>}
                                    </label>
                                    <label>
                                        Password
                                        <input type="password" onChange={this.handlePassword}/>
                                        {this.state.passwordError && <p className="error"><small>{this.state.passwordError}</small></p>}  
                                    </label>
                                    <button type="submit" className="btn btn-green-full">
                                        <i className="fa fa-lock"></i> 
                                        {!this.state.noResponse? 'Signing in...' : 'Sign in'}
                                    </button>
                                    {!this.state.noResponse && <div className="loader"><img src={xsmallLoader} alt=''/></div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js